var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79289 9.3271L1.77075 3.30496C1.75774 3.29283 1.7449 3.28044 1.73223 3.26777L1.02513 2.56066C0.43934 1.97487 0.43934 1.02513 1.02513 0.43934C1.61091 -0.146447 2.56066 -0.146447 3.14645 0.43934L3.47421 0.767105L3.47487 0.766442L10.2678 7.55933C11.2441 8.53564 11.2441 10.1186 10.2678 11.0949L3.85354 17.5091L3.47487 17.8878L3.14643 18.2162C2.56064 18.802 1.6109 18.802 1.02511 18.2162C0.439322 17.6304 0.439322 16.6807 1.02511 16.0949L1.35355 15.7664L1.73222 15.3878C1.73365 15.3863 1.7351 15.3849 1.73654 15.3835L7.79289 9.3271Z",
    fill: "#7E98DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.a5bcba10ade5211c7494d8eca8bf3c5a.svg";
export { ForwardRef as ReactComponent };